import createPinia from '@/core/pinia.js'
import createRouter from '@/core/router.js'
import createApp from '@/spa.js'

let state = window.VITE_STATE

// Mount application.
createApp(createRouter(), createPinia(), state).mount('#app')
